import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "form-group mb-2 me-2 col-md-4 col-lg-4 col-xl-4" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "form-group mb-2 me-2 col-md-5 col-lg-5 col-xl-5" }
const _hoisted_11 = { class: "d-flex align-items-center gap-1" }
const _hoisted_12 = { class: "col-form-label text-capitalize-first p-0 me-1" }
const _hoisted_13 = {
  key: 0,
  class: "w-100"
}
const _hoisted_14 = { class: "form-group mb-2 col" }
const _hoisted_15 = { class: "col-auto p-0 text-end" }
const _hoisted_16 = { class: "col-sm-12" }
const _hoisted_17 = { class: "card card-body" }
const _hoisted_18 = { class: "overflow-auto" }
const _hoisted_19 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = { class: "text-capitalize-first" }
const _hoisted_26 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_27 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "text-secondary" }
const _hoisted_30 = {
  key: 2,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_31 = {
  class: "d-flex",
  style: {"clear":"both"}
}
const _hoisted_32 = {
  key: 0,
  class: "fa fa-spin fa-spinner text-primary"
}
const _hoisted_33 = {
  key: 1,
  class: "fa fa-rotate-left text-warning"
}
const _hoisted_34 = {
  key: 2,
  class: "fa fa-warning text-warning"
}
const _hoisted_35 = { class: "text-secondary" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "text-secondary" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["href"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "text-danger fa fa-warning"
}
const _hoisted_44 = {
  key: 1,
  class: "text-success fa fa-check"
}
const _hoisted_45 = { class: "ms-1" }
const _hoisted_46 = { class: "ms-1" }
const _hoisted_47 = { class: "ms-1" }
const _hoisted_48 = { class: "ms-1" }
const _hoisted_49 = { class: "text-end" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_SearchDepositModal = _resolveComponent("SearchDepositModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: Object.values(_ctx.DepositStatus),
                          "custom-label": (opt) => _ctx.helper.trans(`deposit_status.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.status')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.helper.trans("labels.owner")) + ":", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-dark text-capitalize-first",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleType()), ["prevent"]))
                      }, _toDisplayString(_ctx.accountType ? _ctx.helper.trans(`labels.${_ctx.accountType}`) : _ctx.helper.trans(`labels.select`)), 1),
                      (_ctx.accountType && _ctx.accountType !== 'system')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_Multiselect, {
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.account,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.account) = $event)),
                              options: _ctx.accounts,
                              "custom-label": (opt) => _ctx.labelFor(_ctx.accountType!, opt),
                              "track-by": "id",
                              "select-label": "Select",
                              "open-direction": "bottom",
                              multiple: false,
                              searchable: true,
                              loading: _ctx.isLoading,
                              "internal-search": false,
                              "clear-on-select": true,
                              "close-on-select": true,
                              "options-limit": 100,
                              limit: 1000,
                              "show-no-results": false,
                              "hide-selected": false,
                              onSearchChange: _ctx.asyncFindAccounts
                            }, null, 8, ["modelValue", "options", "custom-label", "loading", "onSearchChange"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.accountType)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-sm btn-link",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.clearType()), ["prevent"]))
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(() => { _ctx.searchDepositModal?.show(); }, ["prevent"])),
                            class: "btn btn-outline-info btn-sm rounded-pill me-2 text-capitalize-first"
                          }, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.helper.trans('button.search_deposits')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => _ctx.exportData(), ["prevent"])),
                        class: "btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first"
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-download me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.helper.trans('button.export')), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("table", _hoisted_19, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans("labels.owner")), 1),
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.from_address.usdt')), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.tx_id')), 1),
                        (_ctx.isAdmin || _ctx.isOperator)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.aml_result')), 1))
                          : _createCommentVNode("", true),
                        _cache[13] || (_cache[13] = _createElementVNode("th", { class: "text-end" }, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (deposit) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: deposit.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("span", null, [
                                _withDirectives((_openBlock(), _createElementBlock("span", {
                                  title: deposit.id
                                }, [
                                  _createTextVNode(_toDisplayString(deposit.id.substring(0, 8)) + "...", 1)
                                ], 8, _hoisted_28)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ]),
                                _cache[14] || (_cache[14] = _createTextVNode()),
                                _createVNode(_component_copy_button, {
                                  value: deposit.id
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("small", _hoisted_29, _toDisplayString(_ctx.dateHelper.format(deposit.createdAt)), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (deposit._traderAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  "show-badge": "",
                                  user: deposit._traderAccount.user
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (deposit._userAccount)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 1,
                                  "show-badge": "",
                                  user: deposit._userAccount.user
                                }, null, 8, ["user"]))
                              : _createCommentVNode("", true),
                            (deposit._merchantStoreAccount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_UserNameLabel, {
                                      "show-badge": "",
                                      user: deposit._merchantStoreAccount.user
                                    }, null, 8, ["user"]),
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(deposit._merchantStoreAccount?.storeName), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(_ctx.helper.trans(`deposit_status.${deposit.status}`)) + " ", 1),
                              (deposit.status === _ctx.DepositStatus.NEW || deposit.status === _ctx.DepositStatus.RETURN_IN_PROGRESS)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_32))
                                : _createCommentVNode("", true),
                              (deposit.status === _ctx.DepositStatus.RETURNED)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                                : _createCommentVNode("", true),
                              (deposit.status === _ctx.DepositStatus.REJECTED)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.dateHelper.format(deposit.updatedAt)), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deposit.sum, 2)) + " ", 1),
                            (deposit.sum.currency !== deposit.creditedSum.currency)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("small", _hoisted_37, _toDisplayString(_ctx.numberFormatter.formatMoney(deposit.creditedSum, 2)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(deposit.fromAddress), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(deposit.txId.substring(0, 16)) + "... ", 1),
                              _createVNode(_component_copy_button, {
                                value: deposit.txId
                              }, null, 8, ["value"]),
                              _createElementVNode("a", {
                                href: `https://tronscan.org/#/transaction/${deposit.txId}`,
                                target: "_blank",
                                class: "ms-2"
                              }, _cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "fa fa-external-link" }, null, -1)
                              ]), 8, _hoisted_38)
                            ]),
                            (deposit.returnedTxId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createTextVNode(_toDisplayString(deposit.returnedTxId!.substring(0, 16)) + "... ", 1),
                                  _createVNode(_component_copy_button, {
                                    value: deposit.returnedTxId
                                  }, null, 8, ["value"]),
                                  _createElementVNode("a", {
                                    href: `https://tronscan.org/#/transaction/${deposit.returnedTxId}`,
                                    target: "_blank",
                                    class: "ms-2"
                                  }, _cache[16] || (_cache[16] = [
                                    _createElementVNode("i", { class: "fa fa-external-link" }, null, -1)
                                  ]), 8, _hoisted_40)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.isAdmin || _ctx.isOperator)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                (deposit.amlResult)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      (deposit.amlResult.riskScore.risky)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_43))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_44)),
                                      _createElementVNode("small", _hoisted_45, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.total) * 100, 2)) + "%", 1)
                                      ]),
                                      _createElementVNode("small", _hoisted_46, "l: " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.low) * 100, 2)) + "%", 1),
                                      _createElementVNode("small", _hoisted_47, "m: " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.medium) * 100, 2)) + "%", 1),
                                      _createElementVNode("small", _hoisted_48, "h: " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.high) * 100, 2)) + "%", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_49, [
                            ((_ctx.isAdmin || (_ctx.isOperator && _ctx.store.getters.hasPermission(_ctx.UserPermission.ACCEPT_AML_REJECTED_DEPOSITS))) && (deposit.status === _ctx.DepositStatus.REJECTED || deposit.canRecheckAml))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.processDeposit(deposit)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, _toDisplayString(_ctx.helper.trans('button.process_deposit')), 9, _hoisted_50))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin && deposit.status === _ctx.DepositStatus.REJECTED)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.returnDeposit(deposit)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                                }, _toDisplayString(_ctx.helper.trans('button.return_deposit')), 9, _hoisted_51))
                              : _createCommentVNode("", true),
                            (_ctx.isAdmin && deposit.canRecheckAml)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  onClick: ($event: any) => (_ctx.renewAmlDepositCheck(deposit)),
                                  type: "button",
                                  class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.recheck_aml')), 9, _hoisted_52))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[9] || (_cache[9] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
      _createVNode(_component_SearchDepositModal, {
        ref: "searchDepositModal",
        "onDeposit:credited": _ctx.load
      }, null, 8, ["onDeposit:credited"])
    ]),
    _: 1
  }, 512))
}